import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";
import { LandingFaq } from "../LandingFaq/LandingFaq";
import { CommonContainerPropsComponent } from "../../../api/content-client/service";

interface Props {
  body?: any;
  containerProps?: CommonContainerPropsComponent;
  items?: Record<string, any>[] | null;
  title?: string | null;
}

export function ContentRendererFaq(block: Props) {
  const {
    body,
    containerProps,
    items,
    title,
  } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <LandingFaq
        items={items}
        title={title}
      >
        <ContentRendererBody
          body={body}
          paragraphVariant="bodyLg"
        />
      </LandingFaq>
    </ContentRendererContainer>
  );
}
